import React from 'react';

export default function FloatingCTA() {
  const actions = [
    {
      id: 'phone',
      href: 'tel:22426011',
      icon: 'fa-solid fa-phone',
      label: 'Ring til os',
      bgColor: 'bg-emerald-600 hover:bg-emerald-500 focus:ring-emerald-500',
      ariaLabel: 'Ring til J F D Service på 22 42 60 11',
    },
    {
      id: 'email',
      href: 'mailto:J_danielsen85@hotmail.com',
      icon: 'fa-solid fa-envelope',
      label: 'Send en e-mail',
      bgColor: 'bg-brand-orange hover:bg-brand-orange-hover focus:ring-brand-orange',
      ariaLabel: 'Send en e-mail til J_danielsen85@hotmail.com',
    },
    {
      id: 'facebook',
      href: 'https://facebook.com/profile.php?id=61573571575828',
      icon: 'fa-brands fa-facebook-f',
      label: 'Følg os på Facebook',
      bgColor: 'bg-[#1877f2] hover:bg-[#166fe5] focus:ring-[#1877f2]',
      ariaLabel: 'Besøg vores Facebook-side',
    },
  ];

  return (
    <div className="fixed right-4 bottom-6 z-50 flex flex-col gap-3 sm:right-6 sm:bottom-8 sm:gap-4">
      {actions.map((action) => (
        <div key={action.id} className="group relative flex items-center justify-end">
          {/* Tooltip */}
          <span className="absolute right-14 mr-2 scale-95 rounded bg-slate-900/95 px-3 py-1.5 text-xs font-medium text-white opacity-0 shadow-lg transition-all duration-200 group-hover:scale-100 group-hover:opacity-100 sm:right-16 md:text-sm whitespace-nowrap pointer-events-none">
            {action.label}
          </span>
          
          {/* Button */}
          <a
            href={action.href}
            target={action.id === 'facebook' ? '_blank' : undefined}
            rel={action.id === 'facebook' ? 'noopener noreferrer' : undefined}
            className={`flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition-all duration-300 hover:scale-110 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:h-14 sm:w-14 ${action.bgColor}`}
            aria-label={action.ariaLabel}
          >
            <i className={`${action.icon} text-lg sm:text-xl`} aria-hidden="true" />
          </a>
        </div>
      ))}
    </div>
  );
}
